import React from "react"
import SectionHeading from "../home/SectionHeading.jsx"

// Two-column explainer for a service page (`page.pillars` in data/services.js).
export default function PillarsSection({ eyebrow, heading, lead, items }) {
  return (
    <section aria-labelledby="pillars-heading" className="bg-brand-bg py-16 sm:py-20">
      <div className="mx-auto max-w-6xl px-4 sm:px-6">
        <SectionHeading id="pillars-heading" eyebrow={eyebrow} title={heading} lead={lead} />

        <div className="mt-10 grid gap-6 md:grid-cols-2">
          {items.map((item) => (
            <article
              key={item.label}
              aria-labelledby={`pillar-${item.label}-heading`}
              className="flex flex-col rounded-xl2 border border-brand-border bg-white p-7 shadow-card"
            >
              <p className="inline-flex w-fit rounded-full bg-brand-primarySoft px-3 py-1 text-sm font-bold tracking-wide text-brand-primary">
                {item.label}
              </p>
              <h3
                id={`pillar-${item.label}-heading`}
                className="mt-4 text-xl font-semibold text-brand-heading"
              >
                {item.title}
              </h3>
              <p className="mt-3 leading-relaxed text-brand-textSoft">{item.text}</p>
              <ul className="mt-5 space-y-2.5 border-t border-brand-border pt-5 text-brand-text">
                {item.points.map((point) => (
                  <li key={point} className="flex gap-3">
                    <span
                      aria-hidden="true"
                      className="mt-2.5 h-1.5 w-1.5 shrink-0 rounded-full bg-brand-primary"
                    />
                    {point}
                  </li>
                ))}
              </ul>
            </article>
          ))}
        </div>
      </div>
    </section>
  )
}
